import Doublebox from './doublebox';
import Singlebox from './singlebox';
import Opendesign from './opendesign';
import FreeAccount from './free-account';

import LaunchDarkly from '@module/launchdarkly';
import { EXPERIMENT_FREE_ACCOUNT } from '@constant/experiments';

let component = [Doublebox, Singlebox, Opendesign][
  Math.floor(Math.random() * 3)
];

if (LaunchDarkly.getVariant(EXPERIMENT_FREE_ACCOUNT)) {
  component = FreeAccount;
}

export default component;
